export default __webpack_public_path__ + "static/media/red-envelope.b5dad5e6.svg";